import React, { FunctionComponent } from "react";
import { Header } from "../../../header";

interface ClientInfoHeaderProps {
    title?: string;
    showIcon?: boolean;
    isCouple?: boolean;
    children?: React.ReactNode;
}

const ClientInfoHeader: FunctionComponent<ClientInfoHeaderProps> = ({
    title = "Client",
    showIcon = true,
    isCouple = false,
    children,
}) => {
    const getIconName = () => {
        if (!showIcon) {
            return "";
        }

        if (!isCouple) {
            return "07_ClientInfo";
        }

        return "56_Couple";
    };

    return (
        <div className="flex flex-wrap justify-between">
            <div className="flex flex-col mr-4 last:mr-0">
                <Header iconName={getIconName()}>{title}</Header>
            </div>
            {children}
        </div>
    );
};

export default ClientInfoHeader;
